import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';

const BillingAppNavigation: FuseNavItemType = {
	id: 'apps.billing',
	title: 'Billing',
	type: 'collapse',
	icon: 'heroicons-outline:credit-card',
	url: '/apps/billing/plans',
	children: [
		{
			id: 'apps.billing.plans',
			title: 'Plans',
			type: 'item',
			url: '/apps/billing/plans',
		},
		{
			id: 'apps.billing.subscriptions',
			title: 'Subscriptions',
			type: 'item',
			url: '/apps/billing/subscriptions',
		},
		{
			id: 'apps.billing.payment-method',
			title: 'Payment Method',
			type: 'item',
			url: '/apps/billing/payment-method',
		}
	]
};

export default BillingAppNavigation;
